import { useMutation } from "react-query";
import api from "../../client";
import {
  CreateInstitutionRankingUserPayload,
  InstitutionRanking,
} from "../../types/institution-ranking";

const makeRequest = async (
  payload: CreateInstitutionRankingUserPayload,
): Promise<InstitutionRanking> => {
  const { data } = await api.patch(`/institution-ranking-user`, payload);

  return data;
};

export const useCreateInstitutionRankingUser = () => {
  return useMutation((payload: CreateInstitutionRankingUserPayload) => {
    return makeRequest(payload);
  });
};
